import { render, staticRenderFns } from "./ticketSales.vue?vue&type=template&id=31163618&scoped=true"
import script from "./ticketSales.vue?vue&type=script&lang=js"
export * from "./ticketSales.vue?vue&type=script&lang=js"
import style0 from "./ticketSales.vue?vue&type=style&index=0&id=31163618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31163618",
  null
  
)

export default component.exports